import useSWR from "swr";

export const useProjectionsVsActual = (searchQuery) => {
    const clientsKey = searchQuery ? `/production-category-item/${searchQuery}` : `/production-category-item`;
    const { data, error, mutate } = useSWR(clientsKey);

    return {
        category_item: data,
        isLoading: !error && !data,
        error,
        mutate,
    };
};